import {configureStore} from '@reduxjs/toolkit';

import { countriesReducer } from '../reducers/countries';
import { houseDocumentsReducer } from '../reducers/houseDocuments';
import { filterHouseDocumentsReducer } from '../reducers/filterHouseDocuments';
import { filterHousesReducer } from '../reducers/filterHouses';
import { housesReducer } from '../reducers/houses';
import { houseImagesReducer } from '../reducers/houseImages';
import { qrCodeReducer } from '../reducers/qr';
import { regionsReducer } from '../reducers/regions';
import { rolesReducer } from '../reducers/roles';
import { houseReducer } from '../reducers/singleHouse';
import { userReducer } from "../reducers/user";
import { userInfoReducer } from "../reducers/userInfo";
import { documentTypesReducer } from '../reducers/documentTypes';
import { houseTxReducer } from '../reducers/houseTx';
import { publicKeyReducer } from '../reducers/publicKey';

import { getAllCountries } from '../actions/countries';
import { getAllRegions } from '../actions/regions';
import { getAllRoles } from '../actions/roles';
import { getAllDocumentTypes } from '../actions/documentTypes';
import { getPublicKey } from '../actions/publicKey';

export const store = configureStore({
    reducer: {
        qrCode: qrCodeReducer,
        houseTx: houseTxReducer,
        filterHouses: filterHousesReducer,
        filterHouseDocuments: filterHouseDocumentsReducer,
        roles: rolesReducer,
        countries: countriesReducer,
        regions: regionsReducer,
        documentTypes: documentTypesReducer,
        houseDocuments: houseDocumentsReducer,
        houseImages: houseImagesReducer,
        house: houseReducer,
        houses: housesReducer,
        user: userReducer,
        userInfo: userInfoReducer,
        publicKey: publicKeyReducer,
    },
});

// Initialize
store.dispatch(getAllRoles());
store.dispatch(getAllCountries());
store.dispatch(getAllRegions());
store.dispatch(getAllDocumentTypes());
store.dispatch(getPublicKey());

// store.subscribe(() => console.log(store.getState()));
